<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Remove Member</p-heading>

  <p-text>
    Are you sure you want to remove {{ user?.firstName }} {{ user?.lastName }} from
    {{ group?.name }}?
  </p-text>

  <p-button-group slot="footer">
    <p-button [loading]="(submitting$ | async) ?? false" (click)="submit()">Confirm</p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
